<div class="confirm-modal">
  <img src="../../../../assets/img/sent_demand.png" alt="sent demand" />
  <p class="confirm-modal__message">
    {{ "MODALS.DEMAND_SENT.MESSAGE" | translate }}
  </p>
  <div class="confirm-modal__buttons">
    <app-button
      [innerText]="'MODALS.DEMAND_SENT.BUTTON' | translate"
      (onClick)="handleCancle()"
    ></app-button>
  </div>
</div>
